import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "products-page" }
const _hoisted_2 = { class: "products-grid" }

import {BatteryCharging, Droplets, ShieldCheck, Sparkles} from "lucide-vue-next";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductView',
  setup(__props) {

const productAreas = [
  {
    icon: Droplets,
    title: "Öle & Flüssigkeiten",
    text: "Motoröl, Bremsflüssigkeit, Kühlmittel und passende Pflege für Ihr Fahrzeug."
  },
  {
    icon: BatteryCharging,
    title: "Batterien & Verschleißteile",
    text: "Sinnvolle Ersatzteile mit Beratung, damit Qualität und Fahrzeug zusammenpassen."
  },
  {
    icon: Sparkles,
    title: "Pflege & Zubehör",
    text: "Praktisches Zubehör für Werterhalt, Innenraum, Winterbetrieb und Alltag."
  },
  {
    icon: ShieldCheck,
    title: "Beratung vor Ort",
    text: "Wir empfehlen nur Produkte, die technisch sinnvoll und wirtschaftlich fair sind."
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("section", { class: "products-hero" }, [
      _createElementVNode("h1", null, "Produkte & Zubehör"),
      _createElementVNode("p", null, "Alles rund ums Fahrzeug: sinnvoll ausgewählt, passend beraten und direkt mit Werkstatt-Know-how empfohlen.")
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productAreas, (area) => {
        return _createElementVNode("article", {
          class: "product-card",
          key: area.title
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(area.icon), { class: "product-icon" })),
          _createElementVNode("h2", null, _toDisplayString(area.title), 1),
          _createElementVNode("p", null, _toDisplayString(area.text), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})